import React from 'react';

const MachineCard = ({ title, children }) => {
  return (
    <article className="machine-item bg-primary-green-dark/30 backdrop-blur-md rounded-2xl p-4 md:p-6 text-center border border-primary-green-light/30 shadow-card">
      <h3 className="text-lg md:text-xl font-semibold mb-4 text-white">{title}</h3>
      {children}
    </article>
  );
};

const Machines = () => {
  return (
    <section id="machines" className="machines py-12 md:py-24 px-[5%] bg-gradient-to-b from-primary-green-dark to-primary-dark" aria-labelledby="machines-heading">
      <h2 id="machines-heading" className="section-title text-center text-3xl md:text-4xl lg:text-5xl font-bold mb-8 md:mb-12 bg-gradient-to-r from-white via-primary-green-light to-accent-gold bg-clip-text text-transparent" aria-label="Best VMC work and best CNC work capability in Makarpura GIDC">
        Our Advanced Machinery
      </h2>

      <div className="machines-grid grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 max-w-[1400px] mx-auto mt-8 md:mt-16">
        <MachineCard title="COSMOS VMC CNC Machines">
          <ul className="text-left mt-4 space-y-2 text-sm md:text-base text-primary-green-light/90">
            <li>&bull; VMC 1370</li>
            <li>&bull; VMC 1050</li>
            <li>&bull; VMC 800 (x2)</li>
            <li>&bull; 4th Axis machining capability</li>
          </ul>
          <p className="mt-4 italic text-sm md:text-base text-primary-green-light/90">
            CVM Series - High Precision Guaranteed for complex multi-side components
          </p>
        </MachineCard>

        <MachineCard title="Our Capabilities">
          <p className="text-sm md:text-base text-primary-green-light/90">
            Produce precision VMC machined parts based on customer demand, including 4th Axis operations for accurate indexing, rotary machining, and complex high precision components.
          </p>
          <p className="sr-only">
            Custom machined parts as per customer requirements for best CNC work, best VMC work and best company for CNC machining needs in Vadodara.
          </p>
        </MachineCard>
      </div>
    </section>
  );
};

export default Machines;
